module.exports = __webpack_public_path__ + "static/media/icon-report-high-score-a.631bdc72.svg";